<template>
  <p>
    Online registration for the main conference and tutorials has now closed, however late
    registration may be possible &mdash; please contact the
    <router-link to="../Contact">EMBL conference office</router-link>. Online registration for
    virtual participation is still open. Note that virtual participation in tutorials is not
    possible.
  </p>
  <p><strong>Registration Fees:</strong></p>
  <table>
    <tbody>
      <tr>
        <td>Academia:</td>
        <td>450 Euro</td>
      </tr>
      <tr>
        <td>PhD Student:</td>
        <td>400 Euro</td>
      </tr>
      <tr>
        <td>Industry:</td>
        <td>725 Euro</td>
      </tr>
      <tr>
        <td>Virtual Participation:</td>
        <td>100 Euro</td>
      </tr>
      <tr>
        <td>Tutorials:</td>
        <td>75 Euro per tutorial</td>
      </tr>
    </tbody>
  </table>
  <p>
    Registration includes admission to the conference, conference materials, meals and coffee
    breaks; accommodation is not included. For information about hotels and transport, please see
    the <router-link to="../Venue">Venue page</router-link>. Please note:
    <strong>VIZBI Tutorials are not included in the conference registration fee.</strong>
  </p>
  <h4>Virtual Participation</h4>
  <p>
    For VIZBI 2014 we offered &lsquo;virtual participation&rsquo;, which allowed access to a live
    web stream of high-quality video covering all scheduled talks during the main conference (not
    tutorials). The web streaming service also allowed virtual participants to type in questions for
    the speaker via chat, which were passed to the session chair. Virtual participants could also
    choose to upload a short video displayed during one of the Lightning Talk sessions &mdash; for
    details, see the <router-link to="../Posters#Virtual">Posters page</router-link>.
  </p>
  <h4>ISCB Discount</h4>
  <p>
    Members of the
    <a href="http://iscb.org/">International Society for Computational Biology (ISCB)</a> received
    a 15% registration discount.
  </p>
  <h4 id="CPP">CPP Registration Fellowships</h4>
  <p>
    A limited number of EMBL Advanced Training Centre
    <a href="http://www.embl.de/aboutus/resource_dev/cpp/partners/index.html"
    >Corporate Partnership Programme (CPP)</a
    >
    fellowships provided two different kinds of support:
  </p>
  <p>
    <strong>Registration Fee Waiver:</strong> The sum paid to attend the meeting was reimbursed.
  </p>
  <p>
    <strong>Travel Grant:</strong> Up to &euro;400 for participants travelling from the European
    continent and up to &euro;1000 for participants travelling from outside Europe.
  </p>
</template>
